import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=18da15d0&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=18da15d0&prod&scoped=true&lang=css"
import style1 from "./Rooms.vue?vue&type=style&index=1&id=18da15d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da15d0",
  null
  
)

export default component.exports